module.exports = __webpack_public_path__ + "50d6d02c729dabdda40faee1721c2bfa.png";